import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
import { StaticHeightCard } from '../Step2_Review&Checkout/styles';

const { typography, color } = primitives;

export const ShippingAddressCard = styled(StaticHeightCard)`
  flex: 1 1 0;
  border: 1px solid ${color.gray3};
  border-radius: 8px;
  background-color: #ffffff;
  font-family: ${typography.family0};
  padding: 24px !important;
  box-shadow: none !important;
  min-height: auto !important;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 42px;
`;

export const CardTitle = styled.h3`
  font-family: ${typography.family0};
  font-size: ${typography.size4};
  line-height: ${typography.lineHeight4};
  font-weight: ${typography.weight4};
  text-transform: none;
`;

export const UserAddressDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AddressDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const UserName = styled.p`
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  font-weight: ${typography.weight3};
`;

export const AddressLine = styled.p`
  font-size: ${typography.size0};
  line-height: ${typography.lineHeight1};
  font-weight: ${typography.weight3};
`;

export const ManageShippingAddressLink = styled.a`
  color: ${color.electricBlue7};
  text-decoration: underline;
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  font-weight: ${typography.weight4};
  cursor: pointer;

  &:hover {
    color: ${color.electricBlue8};
    text-decoration: underline;
  }

  &:focus {
    color: ${color.electricBlue8};
  }
`;
